import { useNavigate } from 'react-router-dom';
import { useAcademy } from '@/components/academy/AcademyProvider';
import { Checkbox } from '@/components/ui/checkbox';
import { Progress } from '@/components/ui/progress';
import { PlayCircle, FileText, ChevronRight } from 'lucide-react';
import { CertificateButton } from '@/components/academy/CertificateButton';

export function AcademyChecklist() {
  const { content, completed, toggle, startTour, openPdf } = useAcademy();
  const navigate = useNavigate();
  const items = content.checklist;
  const done = items.filter(i => completed.includes(i.id)).length;
  const pct = items.length ? Math.round((done / items.length) * 100) : 0;

  return (
    <section className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5 md:p-6" data-testid="academy-checklist">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div>
          <h2 className="font-chivo font-black text-lg text-navy dark:text-white">Kom igång med Vapelarm Cloud</h2>
          <p className="text-xs text-slate-400 font-ibm mt-0.5">Din personliga checklista – sparas på ditt konto.</p>
        </div>
        <p className="font-ibm text-sm font-semibold text-navy dark:text-white" data-testid="academy-checklist-progress">
          {done} av {items.length} steg klara – {pct} %
        </p>
      </div>
      <Progress value={pct} className="h-2 mt-3 [&>div]:bg-emerald-500" data-testid="academy-checklist-bar" />
      <ul className="mt-4 divide-y divide-slate-100 dark:divide-slate-700">
        {items.map(item => {
          const checked = completed.includes(item.id);
          return (
            <li key={item.id} className="flex items-center gap-3 py-2.5" data-testid={`checklist-item-${item.id}`}>
              <Checkbox
                checked={checked}
                onCheckedChange={v => toggle(item.id, !!v)}
                disabled={item.auto}
                id={`chk-${item.id}`}
                data-testid={`checklist-checkbox-${item.id}`}
              />
              <label htmlFor={`chk-${item.id}`} className={`flex-1 text-sm font-ibm cursor-pointer ${checked ? 'text-slate-400 line-through' : 'text-slate-700 dark:text-slate-200'}`}>
                {item.label}
              </label>
              {item.tour && content.tours[item.tour] && (
                <button onClick={() => startTour(item.tour)} className="text-xs font-ibm text-red-600 hover:underline flex items-center gap-1" data-testid={`checklist-tour-${item.id}`}>
                  <PlayCircle className="h-3.5 w-3.5" /><span className="hidden sm:inline">Visa mig</span>
                </button>
              )}
              {item.document && (
                <button onClick={() => openPdf(item.document)} className="text-xs font-ibm text-red-600 hover:underline flex items-center gap-1" data-testid={`checklist-doc-${item.id}`}>
                  <FileText className="h-3.5 w-3.5" /><span className="hidden sm:inline">Snabbguide</span>
                </button>
              )}
              {item.lesson && (
                <button onClick={() => navigate(`/academy/${item.lesson}`)} className="text-slate-300 hover:text-navy" data-testid={`checklist-lesson-${item.id}`} aria-label="Öppna lektion">
                  <ChevronRight className="h-4 w-4" />
                </button>
              )}
            </li>
          );
        })}
      </ul>
      {items.length > 0 && done === items.length && <CertificateButton />}
    </section>
  );
}
